// src/helpers/factories/menuPrepStationsFactory.ts
var menuPrepStationsFactory = (prepStationIds, prepStations, selectedPrepStationIds = []) => (prepStationIds || []).map((prepStationId) => ({
  id: prepStationId,
  onPress: () => null,
  status: prepStations[prepStationId].active,
  title: prepStations[prepStationId].name,
  isSelected: selectedPrepStationIds.includes(prepStationId),
  isActive: prepStations[prepStationId].active
}));

export { menuPrepStationsFactory };
